import React from "react";
import { Container } from "react-bootstrap";
import ParticleBackground from "../../Shared/ParticleBackground/ParticleBackground";
import TypeWriterEffect from "react-typewriter-effect";

const Banner = () => {
  return (
    <div className="position-relative">
      <ParticleBackground />

      <Container className="text-white position-absolute top-50 start-50 translate-middle">
        <h1 className="text-center">
          <TypeWriterEffect
            textStyle={{
              fontFamily: "Red Hat Display",
              color: "white",
              fontWeight: 500,
              textAlign: "center",
              fontSize: "1.5em",
            }}
            startDelay={0}
            cursorColor="white"
            multiText={[
              "HELLO!!",
              "I'm Alim Imran",
              "From Dhaka, Bangladesh",
              "A Full-Stack MERN developer",
            ]}
            multiTextDelay={1000}
            typeSpeed={80}
            multiTextLoop={true}
          />
        </h1>
        <button className="banner-btn from-left my-4">
          <a
            target="_blank"
            rel="noreferrer"
            href="https://drive.google.com/file/d/1d0753kXWU2NhZnPi9xnb3gEcDD24otuy/view?usp=sharing"
          >
            <span className="common-btn-text">RESUME</span>
          </a>
        </button>
      </Container>
    </div>
  );
};

export default Banner;
